import {
  UploadResponseModel
} from "./../models/cm-model";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';

@Injectable({
providedIn: 'root'
})
export class FileDownloadService {
public data!: any[];
public presignedurls: any[] = [];
constructor(private http: HttpClient) { }

DownloadFromPresignURL(model: any){
  this.data = model;
  //this.DownloadFromSignPresignURL(this.data[0]["PresignedURL"]);
  // this.presignedurls.push(this.data[0]["PresignedURL"]);
  this.data.forEach(element => {
      this.presignedurls.push(element["PresignedURL"]);
      //this.DownloadFromSignPresignURL(element["PresignedURL"]);
  });
  this.downloadAndZipFiles(this.presignedurls, "DownloadedFiles" )
}

async downloadAndZipFiles(urls: string[], zipFileName: string) {
 const zip = new JSZip();
  const filePromises = urls.map(async (url, index) => {
    const fileBlob = await this.http.get(url, { responseType: 'blob' }).toPromise();
    const fileName = this.getFileNameFromUrl(url, index);
    zip.file(fileName, fileBlob);
  });

  await Promise.all(filePromises);

  zip.generateAsync({ type: 'blob' }).then((content) => {
    saveAs(content, `${zipFileName}.zip`);
  });
}

private getFileNameFromUrl(url: string, index: number): string {
  
  const urlParts = url.split('/');
  const name = urlParts[urlParts.length - 1];
  return name.split('?')[0] || `file${index + 1}`;
}

// downloadFilesAsZip(urls: string[], zipFileName: string): void {
//   const requests: Observable<Blob>[] = urls.map(url => this.http.get(url, { responseType: 'blob' }));

//   forkJoin(requests).subscribe(blobs => {
//     const zipData = this.createZipData(blobs, urls);
//     const blob = new Blob([zipData], { type: 'application/zip' });
//     const url = window.URL.createObjectURL(blob);

//     const a = document.createElement('a');
//     a.href = url;
//     a.download = zipFileName;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     window.URL.revokeObjectURL(url);
//   });
// }

// private createZipData(blobs: Blob[], urls: string[]): Uint8Array {
//   // Implement a simplified ZIP file format (not recommended for production)
//   // This is a placeholder implementation for demonstration purposes
//   const zipData = new Uint8Array(); // Placeholder for actual ZIP binary data
//   // Add your ZIP creation logic here using blobs and URLs
//   return zipData;
// }




SingleDownloadFromPresignURL(PresignedURL : string){
          
  this.downloadFile(PresignedURL).subscribe(blob => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = this.getFileNameFromUrl(PresignedURL, 0);
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
  }, error => {
  console.error('Download failed', error);
  });
}

downloadFile(url: string): Observable<Blob> {
  return this.http.get(url, { responseType: 'blob' });
}
}
